import Router from 'next/router';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import { storeAPIs } from 'apis/services';
import { ActionTypeEnum } from 'redux/ActionTypeEnum';
import { loadingAction } from 'redux/settings/action';
import { decodeQueryStrings } from 'utility/decodeURL';

import {
	branchActionSuccess,
	getInstallmentActionSuccess,
	similarSuppliersActionSuccess,
	supplierInfoActionSuccess,
	widgetsActionSuccess,
} from './action';

// get Supplier info
function* storeDetailsRequest({ payload, meta }) {
	try {
		yield put(loadingAction({ skeleton: true }));
		const response = yield call(storeAPIs.info, payload);

		yield put(supplierInfoActionSuccess(response.data?.Content?.SupplierInfo));
		yield put(loadingAction({ skeleton: false }));
	} catch (error) {
		yield put({ type: ActionTypeEnum.error, payload: error, meta });
	}
}

// get Similar Supplier
function* similarSupplierRequest({ payload, meta }) {
	try {
		yield put(loadingAction({ form: true }));
		const response = yield call(storeAPIs.similar, payload);
		yield put(similarSuppliersActionSuccess(response.data?.Content?.Supplier));
		yield put(loadingAction({ form: false }));
	} catch (error) {
		yield put({ type: ActionTypeEnum.error, payload: error, meta });
	}
}

// get branches filter
function* branchesRequest({ payload, meta }) {
	// eslint-disable-next-line no-unused-vars
	const { app_keepa, sponsor_id, ...rest } = payload;
	try {
		yield put(loadingAction({ skeleton: true }));
		const response = yield call(storeAPIs.branches, rest);
		yield put(branchActionSuccess(response.data?.Content));
		yield put(loadingAction({ skeleton: false }));

		// closeable modal
		meta?.mode === 'submit' && meta?.close?.();

		if (meta?.Router && meta?.parsLocation) {
			const storeID = Router.router.state.query.all.join('/');
			Router.push(
				{
					pathname: `/stores/${storeID}`,
					query: decodeQueryStrings({
						...meta?.parsLocation,
					}),
				},
				undefined,
				{
					shallow: true,
				},
			);
			meta?.sst?.(meta.parsLocation);
		}
	} catch (error) {
		yield put({ type: ActionTypeEnum.error, payload: error, meta });
	}
}

// getting widgets
function* getWidgets({ payload, meta }) {
	try {
		yield put(loadingAction({ skeleton: true }));
		const response = yield call(storeAPIs.getWidget, payload);
		yield put(widgetsActionSuccess(response.data?.Content?.Zones));
		yield put(loadingAction({ skeleton: false }));
	} catch (error) {
		yield put({ type: ActionTypeEnum.error, payload: error, meta });
	}
}

// installments
function* getInstallments({ payload, meta }) {
	try {
		yield put(loadingAction({ skeleton: true }));
		const response = yield call(storeAPIs.getInstallment, payload);
		yield put(getInstallmentActionSuccess(response.data?.Content));
		yield put(loadingAction({ skeleton: true }));
	} catch (error) {
		yield put({ type: ActionTypeEnum.error, payload: error, meta });
	}
}

export default function* storesSaga() {
	yield all([
		takeLatest(ActionTypeEnum.supplier_info_request, storeDetailsRequest),
		takeLatest(ActionTypeEnum.similar_suppliers_request, similarSupplierRequest),
		takeLatest(ActionTypeEnum.branch_request, branchesRequest),
		takeLatest(ActionTypeEnum.widget_request, getWidgets),
		takeLatest(ActionTypeEnum.installment_request, getInstallments),
	]);
}
